<!-- eslint-disable max-len -->
<template>
  <!-- PLUGIN CREATE DRAWER -->
  <RightSideDrawer
    v-model:show="showCreateModal"
    bg-color="bg-gray-100"
  >
    <template #header>
      <DialogTitle class="px-4 py-6 sm:px-6 ">
        <p class="text-base font-semibold text-gray-900">
          {{ t('plugins.manager.create.title') }}
        </p>
        <p class="mt-1 text-md text-gray-900">
          {{ t('plugins.manager.create.description') }}
        </p>
      </DialogTitle>
    </template>

    <template #content>
      <ul class="divide-y divide-gray-100">
        <ListItemPluginIntegration
          :logo="InstagramLogo"
          title="Instagram"
          :description="t('plugins.manager.create.instagram.description')"
          :on-click="instagramConnect"
        />

        <!-- Facebook desabilitado por enquanto. Para habilitar, remova
             :availability-text e :is-disabled. Para desabilitar novamente,
             restaure essas duas props; mantenha :on-click. -->
        <ListItemPluginIntegration
          :logo="FacebookLogo"
          title="Facebook"
          :description="t('plugins.manager.create.facebook.description')"
          :availability-text="t('plugins.manager.create.comingSoon')"
          :is-disabled="true"
          :on-click="facebookConnect"
        />

        <ListItemPluginIntegration
          :logo="TiktokLogo"
          title="Tiktok"
          :description="t('plugins.manager.create.tiktok.description')"
          :availability-text="t('plugins.manager.create.comingSoon')"
          :is-disabled="true"
        />

        <ListItemPluginIntegration
          :logo="YoutubeLogo"
          title="Youtube"
          :description="t('plugins.manager.create.youtube.description')"
          :availability-text="t('plugins.manager.create.comingSoon')"
          :is-disabled="true"
        />

        <ListItemPluginIntegration
          :logo="ShopifyLogo"
          title="Shopify"
          :description="t('plugins.manager.create.shopify.description')"
          :availability-text="t('plugins.manager.create.comingSoon')"
          :is-disabled="true"
        />
      </ul>
    </template>
  </RightSideDrawer>

  <!-- INSTAGRAM PLUGIN CREATE DRAWER -->
  <RightSideDrawer
    v-model:show="showInstagramConnectModal"
    :on-close="instagramConnectClose"
    bg-color="bg-gray-100"
  >
    <template #header>
      <DialogTitle class="px-4 py-6 sm:px-6 ">
        <p class="text-base font-semibold text-gray-900">
          {{ t('plugins.manager.create.title') }}
        </p>
        <p class="mt-1 text-md text-gray-900">
          {{ t('plugins.manager.create.description') }}
        </p>
      </DialogTitle>
    </template>

    <template #content>
      <div class="">
        <div class="px-4 py-5 sm:p-6">
          <h3 class="text-base font-semibold text-gray-900 flex items-center gap-x-1">
            <img
              class="size-4"
              :src="InstagramLogo"
              alt="Instagram logo"
            >
            Instagram
          </h3>
          <div class="mt-2 max-w-xl text-md text-gray-500">
            <p class="mt-2">
              {{ t('plugins.manager.create.details.instagram.description1') }}
            </p>
            <p class="mt-2">
              {{ t('plugins.manager.create.details.instagram.description2') }}
            </p>
            <p class="mt-2">
              {{ t('plugins.manager.create.details.instagram.description3') }}
            </p>
            <p class="mt-2">
              {{ t('plugins.manager.create.details.instagram.description4') }}
            </p>
          </div>
          <div class="mt-5">
            <button
              type="button"
              class="inline-flex items-center rounded-md bg-teal-500 px-3 py-2 text-md font-semibold text-white shadow-xs hover:bg-teal-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
              @click="instagramConnectStart"
            >
              {{ t('plugins.manager.create.details.instagram.connect') }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </RightSideDrawer>

  <!-- FACEBOOK PLUGIN CREATE DRAWER -->
  <RightSideDrawer
    v-model:show="showFacebookConnectModal"
    :on-close="facebookConnectClose"
    bg-color="bg-gray-100"
  >
    <template #header>
      <DialogTitle class="px-4 py-6 sm:px-6 ">
        <p class="text-base font-semibold text-gray-900">
          {{ t('plugins.manager.create.title') }}
        </p>
        <p class="mt-1 text-md text-gray-900">
          {{ t('plugins.manager.create.description') }}
        </p>
      </DialogTitle>
    </template>

    <template #content>
      <div class="">
        <div class="px-4 py-5 sm:p-6">
          <h3 class="text-base font-semibold text-gray-900 flex items-center gap-x-1">
            <img
              class="size-4"
              :src="FacebookLogo"
              alt="Facebook logo"
            >
            Facebook
          </h3>
          <div class="mt-2 max-w-xl text-md text-gray-500">
            <p class="mt-2">
              {{ t('plugins.manager.create.details.facebook.description1') }}
            </p>
            <p class="mt-2">
              {{ t('plugins.manager.create.details.facebook.description2') }}
            </p>
            <p class="mt-2">
              {{ t('plugins.manager.create.details.facebook.description3') }}
            </p>
            <p class="mt-2">
              {{ t('plugins.manager.create.details.facebook.description4') }}
            </p>
            <p
              class="p-4 border-dashed border border-gray-200 rounded-md mt-6"
              v-html="t('plugins.manager.create.details.facebook.warning')"
            />
          </div>
          <div class="mt-5">
            <button
              type="button"
              class="inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-md font-semibold text-white shadow-xs hover:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              @click="facebookConnectStart"
            >
              {{ t('plugins.manager.create.details.facebook.connect') }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </RightSideDrawer>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { DialogTitle } from '@headlessui/vue';
import { useI18n } from 'vue-i18n';
import usePluginStore from '@/store/plugin/plugin';
import RightSideDrawer from '@/components/tailwind/shared/RightSideDrawer.vue';
import ListItemPluginIntegration from '@/components/tailwind/plugin/ListItemPluginIntegration.vue';
import InstagramLogo from '@/assets/images/logo-instagram.png';
import FacebookLogo from '@/assets/images/logo-facebook.svg';
import TiktokLogo from '@/assets/images/logo-tiktok.svg';
import YoutubeLogo from '@/assets/images/logo-youtube.svg';
import ShopifyLogo from '@/assets/images/logo-shopify.svg';

const { t } = useI18n();
const { pluginStore } = usePluginStore();

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  // When set, skips the platform-chooser step and jumps straight to the
  // specific platform's connect drawer. Livvia uses this after already
  // asking the seller which network to connect. Undefined = classic
  // behaviour (open the platform chooser first).
  platform: {
    type: String as () => 'instagram' | 'facebook' | undefined,
    default: undefined,
  },
});

const emit = defineEmits(['update:show']);

const showCreateModal = ref(false);
const showInstagramConnectModal = ref(false);
const showFacebookConnectModal = ref(false);

watch(() => props.show, (newValue) => {
  if (newValue) {
    if (props.platform === 'instagram') {
      showInstagramConnectModal.value = true;
    } else if (props.platform === 'facebook') {
      showFacebookConnectModal.value = true;
    } else {
      showCreateModal.value = true;
    }
  }
});

watch(showCreateModal, (newValue) => {
  if (!newValue && !showInstagramConnectModal.value && !showFacebookConnectModal.value) {
    emit('update:show', false);
  }
});

watch(showInstagramConnectModal, (newValue) => {
  if (!newValue && !showCreateModal.value && !showFacebookConnectModal.value) {
    emit('update:show', false);
  }
});

watch(showFacebookConnectModal, (newValue) => {
  if (!newValue && !showCreateModal.value && !showInstagramConnectModal.value) {
    emit('update:show', false);
  }
});

const resetModals = () => {
  showCreateModal.value = false;
  showInstagramConnectModal.value = false;
  showFacebookConnectModal.value = false;
};

const instagramConnect = () => {
  resetModals();
  showInstagramConnectModal.value = true;
};

const instagramConnectClose = () => {
  resetModals();
  showCreateModal.value = true;
};

const facebookConnect = () => {
  resetModals();
  showFacebookConnectModal.value = true;
};

const facebookConnectClose = () => {
  resetModals();
  showCreateModal.value = true;
};

const instagramConnectStart = () => {
  const queryParams = [
    'client_id=1035072877787285',
    `redirect_uri=${encodeURIComponent(process.env.VUE_APP_INSTAGRAM_REDIRECT_URI || 'https://www.livelink.com.br/plugins/callback/instagram')}`,
    'response_type=code',
    'auth_type=reauthenticate',
    'prompt=consent',
    'display=popup',
  ];
  const instagramUrl = `https://www.instagram.com/oauth/authorize?${queryParams.join('&')}`;
  pluginStore.csrf = Math.random().toString(36).substring(2, 15);
  const scope = 'instagram_business_basic,instagram_business_manage_comments,instagram_business_manage_messages';
  window.location.href = `${instagramUrl}&state=${pluginStore.csrf}&scope=${scope}`;
};

const facebookConnectStart = () => {
  const queryParams = [
    'client_id=489268840559363',
    'redirect_uri=https://www.livelink.com.br/plugins/callback/facebook',
    'response_type=code',
  ];
  const facebookUrl = `https://www.facebook.com/v21.0/dialog/oauth?${queryParams.join('&')}`;
  pluginStore.csrf = Math.random().toString(36).substring(2, 15);
  const scope = 'pages_show_list,pages_read_engagement,pages_read_user_content,pages_manage_metadata,public_profile,email';
  window.location.href = `${facebookUrl}&state=${pluginStore.csrf}&scope=${scope}`;
};

const open = () => {
  showCreateModal.value = true;
};

defineExpose({ open });
</script>
